import React, { useEffect, useRef, useState } from "react";
import Dropdown from "../Common/Dropdown/main";
import {
  FaAddressCard,
  FaCalendarAlt,
  FaMoneyBill,
  FaSpinner,
  FaUser,
} from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { BsChatDots, BsChatDotsFill } from "react-icons/bs";
import { useProperties } from "../../hook/useProperties";
import { useTenants } from "../../hook/useTenents";
import { useUsers } from "../../hook/useUsers";
import SuggestionInput from "../Common/SuggestionInput/main";
import Item from "antd/es/list/Item";

interface PaymentInfo {
  propertyName: string;
  paymentId: string;
  tenantName: string;
  paymentStatus: string;
  paymentCollectedOn: string;
  paymentCollectedBy: string;
  rentOf: string;
  balanceAmount: number;
  paymentMode: string;
  paymentType: string;
  comments: string;
  amountReceived: number;
 // propertyAddress: string;
}

interface PaymentFormProps {
  initialData: PaymentInfo;
  onSubmit: (formData: PaymentInfo) => void;
  onCancel?: () => void;
  isOpen: boolean;
  id?: string;
  isLoading?: boolean;
  setActiveAddressId: (value: any) => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isOpen,
  id,
  isLoading,
  setActiveAddressId,
}) => {
  const { Property, queryClient } = useProperties();
  const { _Tenants } = useTenants();
  const { GetUserById } = useUsers();
  const uid = localStorage.getItem("R_M_uid") as string;
  const [formData, setFormData] = useState<PaymentInfo>(initialData);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const PropertyData = Property({ active: true , delete: false});
  const TenantsData = _Tenants();
  const UsersData = GetUserById(uid);

const useOutsideClick = (callback: () => void) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback]);

  return ref;
};

const [paymentStatusOpen, setPaymentStatusOpen] = useState(false);
const paymentStatusOpenRef = useOutsideClick(() => setPaymentStatusOpen(false));
    const [paymentModeOpen, setPaymentModeOpen] = useState(false);
    const paymentModeOpenRef = useOutsideClick(() => setPaymentModeOpen(false)); 
    const [paymentTypeOpen, setPaymentTypeOpen] = useState(false);
    const paymentTypeOpenRef = useOutsideClick(() => setPaymentTypeOpen(false));

  // try {
  //   getUserById.mutateAsync(uid).then((res) =>{
  //     setFormData({
  //       ...formData,
  //       paymentCollectedBy: res.data.name,
  //     })
  //   })
  // } catch (error) {

  // }
  useEffect(() => {
    setFormData({
      ...initialData,
    });
  }, [initialData]);
  useEffect(() => {
    setFormData({
      ...formData,
      paymentCollectedBy: UsersData.data?.userName ?? "",
    });
  }, [UsersData.data]);
  const handlePaymentStatusClick = () => {
    setPaymentModeOpen(false);
    setPaymentTypeOpen(false);
    setPaymentStatusOpen(!paymentStatusOpen);
};
// console.log("ini",initialData);
const handlePaymentModeClick = () => {
    setPaymentStatusOpen(false);
    setPaymentTypeOpen(false);
    setPaymentModeOpen(!paymentModeOpen);
};

const handlePaymentTypeClick = () => {
    setPaymentStatusOpen(false);
    setPaymentModeOpen(false);
    setPaymentTypeOpen(!paymentTypeOpen);
};
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };


  // const setAddress = (value: number) => {
  //   const allProperties = [
  //     ...(PropertyData as any)?.data?.data?.COMMERCIAL ?? [],
  //     ...(PropertyData as any)?.data?.data?.RESIDENTIAL ?? [],
  //   ];
  //   const selectedProperty = allProperties[value];
  //   const selectedPropertyName = selectedProperty?.propertyName ?? "";
  //   const selectedPropertyId = selectedProperty?.id;
  
  //   // console.log("setAddress function called with index:", value);
  //   // console.log("All Properties:", allProperties);
  //   // console.log("Selected Property:", selectedProperty);
  //   // console.log("Selected Property Name:", selectedPropertyName);
  //   // console.log("Selected Property ID:", selectedPropertyId);
  
  //   setFormData({
  //     ...formData,
  //     propertyName: selectedPropertyName,
  //     tenantName:
  //       TenantsData == undefined
  //         ? ""
  //         : [
  //             ...(TenantsData as any).data?.data?.commercialTenants ?? [],
  //             ...(TenantsData as any).data?.data?.residentialTenants ?? [],
  //           ]?.filter(
  //             (item) => item.propertyAddress?.id === selectedPropertyId
  //           )[0]?.name ?? "",
  //   });
  //   setActiveAddressId(selectedPropertyId);
  // }; 

  const setAddress = (value: number) => {
  const allProperties = [
    ...(PropertyData as any)?.data?.data?.COMMERCIAL ?? [],
    ...(PropertyData as any)?.data?.data?.RESIDENTIAL ?? [],
  ];
  const selectedProperty = allProperties[value];
  const selectedPropertyName = selectedProperty?.propertyName ?? "";
  const selectedPropertyId = selectedProperty?.id;
  const tenantName = selectedProperty?.tenantName ?? ""; // Get tenant name directly from property

  setFormData({
    ...formData,
    propertyName: selectedPropertyName,
    tenantName: tenantName, // Use the tenant name from property data
  });
  setActiveAddressId(selectedPropertyId);
};

  const validate = (): boolean => {
    const newErrors: { [key: string]: string } = {};
    const fields = [
      "propertyName",
      "tenantName",
      "paymentStatus",
      //"propertyAddress",
      "amountReceived",
      "paymentCollectedOn",
      "paymentCollectedBy",
      // "balanceAmount",
      "paymentMode",
      "paymentType",
    ];

    fields.forEach((field) => {
      if (!formData[field as keyof PaymentInfo]) {
        newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
       // console.log(`Validation error: ${field} is required`); // Log mis
      }
    });

    if (isNaN(Number(formData.balanceAmount))) {
      newErrors.balanceAmount = "Balance amount must be a valid number.";
     // console.log("Validation error: Balance amount must be a valid number"); // Log invalid balance amount
    }

    setErrors(newErrors);
   // console.log("Validation errors:", newErrors); // Log all validation error
    return Object.keys(newErrors)?.length === 0;
  };
//old
  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     onSubmit(formData);
  //   }
  // };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
   // console.log("Form submitted"); // Log form submission
    if (validate()) {
    //  console.log("Form data:", formData); // Log form data
      onSubmit(formData);
    } else {
   //   console.log("Validation failed"); // Log validation failure
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="bg-white rounded-lg w-full max-w-3xl h-full  mx-auto p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-lg font-bold">
          Payment Information{" "}
          <span className="text-md italic pr-4">{id ? id : ""}</span>
        </h1>
      </div>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-2">
          <div className="">
            <label
              htmlFor="propertyName"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 h-4 w-4  text-blue-500" />
              Property Name
            </label>
          

              <SuggestionInput
  setActiveValue={(value: string) => {
    //console.log("Selected Property Name from SuggestionInput:", value);
    setFormData({ ...formData, propertyName: value });
  }}
  activeValue={formData?.propertyName}
  loading={PropertyData.isLoading}
  setActiveIndex={(index: number) => {
   // console.log("Selected index from SuggestionInput:", index);
    // Find the actual property object based on the index in the filtered suggestions
    const filteredProperties = [
      ...(PropertyData?.data?.data?.COMMERCIAL ?? []),
      ...(PropertyData?.data?.data?.RESIDENTIAL ?? []),
    ].filter((item) => item.propertyStatus === "OCCUPIED" && item.tenantName);

    const selectedPropertyNameFromSuggestion = filteredProperties[index]?.propertyName;

    const allProperties = [
      ...(PropertyData?.data?.data?.COMMERCIAL ?? []),
      ...(PropertyData?.data?.data?.RESIDENTIAL ?? []),
    ];

    const actualSelectedIndex = allProperties.findIndex(
      (prop) => prop.propertyName === selectedPropertyNameFromSuggestion
    );

    if (actualSelectedIndex !== -1) {
    //  console.log("Actual index in all properties:", actualSelectedIndex);
      setAddress(actualSelectedIndex);
    } else {
     // console.warn("Could not find the selected property in the full list.");
    }
  }}
  suggestions={
    PropertyData.data == undefined
      ? []
      : [
          ...(PropertyData?.data?.data?.COMMERCIAL ?? []),
          ...(PropertyData?.data?.data?.RESIDENTIAL ?? []),
        ]
        .filter((item) => item.propertyStatus === "OCCUPIED" && item.tenantName)
        .map((Item) => Item.propertyName)
  }
/> 

            {/* <input
              type="text"
              id="propertyName"
              value={formData?.propertyName || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            /> */}
            {errors?.propertyName && (
              <p className="text-red-500 text-xs italic">
                {errors?.propertyName}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="tenantName"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 h-4 w-4  text-blue-500" />
              Tenant Name
            </label>
            {/* <SuggestionInput
            
              activeValue={formData?.tenantName}
              loading={TenantsData.isLoading}
              setActiveIndex={setTenantName}
              suggestions={
                TenantsData.data == undefined
                  ? []
                  : TenantsData.data?.data.content.map((Item) => Item.name)
              }
            /> */}
            <input
              disabled={true}
              type="text"
              id="tenantName"
              value={formData?.tenantName || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.tenantName && (
              <p className="text-red-500 text-xs italic">
                {errors?.tenantName}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="paymentStatus"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <RiMoneyRupeeCircleFill className="mr-2 h-4 w-4  text-green-500" />
              Payment Status
            </label>
            {/* <Dropdown
              className=" w-[100%]"
              options={["PAID", "PENDING"]}
              className2="py-2"
              onSelect={(e: any) =>
                setFormData({ ...formData, paymentStatus: e })
              }
              activeOption={formData?.paymentStatus}
              width={305}
            /> */}
             <div
             ref={paymentStatusOpenRef}
              onClick={handlePaymentStatusClick}>
                 <Dropdown
                     className=" w-[100%]"
                      options={["PAID", "PARTIAL"]}
                                className2="py-2"
                                onSelect={(e: any) =>
                                    setFormData({ ...formData, paymentStatus: e })
                                }
                                activeOption={formData?.paymentStatus}
                                width={305}
                                isOpen={paymentStatusOpen}
                                setIsOpen={setPaymentStatusOpen}
                                closeOtherDropdown={()=>{}}
                            />
                        </div>
            {errors?.paymentStatus && (
              <p className="text-red-500 text-xs italic">
                {errors?.paymentStatus}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="paymentCollectedOn"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <RiMoneyRupeeCircleFill className="mr-2 h-4 w-4  text-green-500" />
              Payment Collected On
            </label>

            <input
              type="date"
              id="paymentCollectedOn"
              value={formData?.paymentCollectedOn || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.paymentCollectedOn && (
              <p className="text-red-500 text-xs italic">
                {errors?.paymentCollectedOn}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="paymentCollectedBy"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaUser className="mr-2 h-4 w-4  text-blue-500" />
              Payment Collected By
            </label>
            {/* <SuggestionInput
              activeValue={formData?.paymentCollectedBy}
              loading={UsersData.isLoading}
              setActiveIndex={(value: number) => {
                setFormData({
                  ...formData,
                  paymentCollectedBy:
                    UsersData?.data?.content[value].userName ?? "",
                });
              }}
              suggestions={
                UsersData.data == undefined
                  ? []
                  : UsersData?.data?.content.map((Item) => Item.userName)
              }
            /> */}
            <input
              type="text"
              disabled={true}
              id="paymentCollectedBy"
              placeholder={UsersData.isLoading ? "loading..." : ""}
              value={formData?.paymentCollectedBy || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.paymentCollectedBy && (
              <p className="text-red-500 text-xs italic">
                {errors?.paymentCollectedBy}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="rentOf"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBill className="mr-2 h-4 w-4  text-yellow-500" />
              Rent of Month
            </label>

            {/* <input
              type="date"
              id="paymentCollectedOn"
              value={formData?.paymentCollectedOn || ""}
              onChange={handleChange}
              min={`${new Date().getFullYear() - 1}-01-01`} // January 1st of last year
              max={`${new Date().getFullYear()}-12-31`} // December 31st of current year
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            /> */}

            <input
              type="date"
              id="rentOf"
              value={formData?.rentOf || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.rentOf && (
              <p className="text-red-500 text-xs italic">{errors?.rentOf}</p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="amountReceived"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBill className="mr-2 h-4 w-4  text-yellow-500" />
              Amount Received
            </label>
            <input
              type="number"
              id="amountReceived"
              value={formData?.amountReceived}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.amountReceived && (
              <p className="text-red-500 text-xs italic">
                {errors?.amountReceived}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="paymentMode"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <RiMoneyRupeeCircleFill className="mr-2 h-4 w-4  text-green-500" />
              Payment Mode
            </label>
            {/* <Dropdown
              options={["CASH", "CREDITCARD", "BANKTRANSFER", "UPI"]}
              onSelect={(e: any) =>
                setFormData({ ...formData, paymentMode: e })
              }
              activeOption={formData?.paymentMode}
              className=" w-[100%]"
              className2="py-2"
            /> */}
  <div 
  ref={paymentModeOpenRef}
  onClick={handlePaymentModeClick}>
                            <Dropdown
                            // CASH, UPI, CHECK, BANKTRANSACTION
                                options={["CASH", "UPI", "CHEQUE", "BANKTRANSACTION"]}
                                onSelect={(e: any) =>
                                    setFormData({ ...formData, paymentMode: e })
                                }
                                activeOption={formData?.paymentMode}
                                className=" w-[100%]"
                                className2="py-2"
                                isOpen={paymentModeOpen}
                                setIsOpen={setPaymentModeOpen}
                                closeOtherDropdown={()=>{}}
                            />
                        </div>
            {errors?.paymentMode && (
              <p className="text-red-500 text-xs italic">
                {errors?.paymentMode}
              </p>
            )}
          </div>
          
          <div className="">
            <label
              htmlFor="balanceAmount"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaMoneyBill className="mr-2 h-4 w-4  text-yellow-500" />
              Balance Amount
            </label>
            <input
              type="number"
              id="balanceAmount"
              disabled
              value={formData?.balanceAmount}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.balanceAmount && (
              <p className="text-red-500 text-xs italic">
                {errors?.balanceAmount}
              </p>
            )}
          </div>
          <div className="">
            <label
              htmlFor="paymentType"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <RiMoneyRupeeCircleFill className="mr-2 h-4 w-4  text-green-500" />
              Payment Type
            </label>
            <div 
            ref={paymentTypeOpenRef}
            onClick={handlePaymentTypeClick}>
        <Dropdown
            options={["RENT", "OPENINGBALANCE", "DEPOSIT"]}
            onSelect={(e: any) =>
                setFormData({ ...formData, paymentType: e })
            }
            activeOption={formData?.paymentType}
            className=" w-[100%]"
            className2="py-2"
            isOpen={paymentTypeOpen}
            setIsOpen={setPaymentTypeOpen}
            closeOtherDropdown={()=>{}}
        />
    </div>
            {errors?.paymentMode && (
              <p className="text-red-500 text-xs italic">
                {errors?.paymentType}
              </p>
            )}
          </div>
          {/* <div className="">
            <label
              htmlFor="comments"
              className="text-sm text-gray-700 font-bold flex items-center"
            >
              <FaAddressCard className="mr-2 h-4 w-4  text-green-500" />
              Property Address
            </label>
            <textarea
              disabled={true}
              id="propertyAddress"
              value={formData?.propertyAddress || ""}
              onChange={handleChange}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
            {errors?.propertyAddress && (
              <p className="text-red-500 text-xs italic">
                {errors?.propertyAddress}
              </p>
            )}
          </div> */}
        </div>
        <div className="">
          <label
            htmlFor="comments"
            className="text-sm text-gray-700 font-bold flex items-center"
          >
            <BsChatDotsFill className="mr-2 h-4 w-4  text-green-500" />
            Comments
          </label>
          <textarea
            id="comments"
            value={formData?.comments || ""}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="flex flex-col sm:flex-row justify-end mt-4 space-y-2 sm:space-y-0 sm:space-x-4">
          <button
            disabled={isLoading}
            type="submit"
            className="bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            {isLoading ? (
              <p className="flex justify-center items-center">
                <FaSpinner className="animate-spin mr-2" /> Updating...
              </p>
            ) : (
              "Save"
            )}
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default PaymentForm;